import type { NavigationParameters } from '../index.h'

import { mq } from '~/shared/mq'
import { SnapshotMap } from '../../general/snapshot-map'
import { NavigateEvent } from '../events/navigate'

const SNAPSHOTS_TO_KEEP = 4

/**
 * SnapshotMap to store navigation event parameters with their history
 */
export const parameters = new SnapshotMap<NavigationParameters>(
  SNAPSHOTS_TO_KEEP
)

/* Update parameters */

function fromNavigation(payload: NavigationParameters) {
  const { to, from, type, search, timestamp } = payload

  parameters
    .update('to', to)
    .update('from', from)
    .update('type', type)
    .update('search', search)
    .update('timestamp', timestamp)
    .commit()
    .notify()
}

/* Updates listeners */

// Subscribe to navigation changes from the watcher
mq.on(NavigateEvent, fromNavigation)

/* TODO later for task FP-3869 here could be added logic that watches previous snapshots to generate
"openFrom" field */
